import { render, staticRenderFns } from "./coverage.vue?vue&type=template&id=46f1396e&scoped=true&"
import script from "./coverage.ts?vue&type=script&lang=ts&"
export * from "./coverage.ts?vue&type=script&lang=ts&"
import style0 from "./coverage.scss?vue&type=style&index=0&id=46f1396e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f1396e",
  null
  
)

export default component.exports